import { FunctionComponent, Children } from 'react';
import { FiltersPanel, SINGLE_FILTER_HEADER_HEIGHT } from '@cbridge-tools/filters-panel';
import { ResizeHandle } from '@cbridge-tools/resize-handle';
import { FlexNavigationPanel } from '../FlexNavigationPanel/FlexNavigationPanel';
import { ISideFilterPanelProps } from './SideFilterPanel.interface';

const DEFAULT_PANEL_ID = 'filters';

export const SideFilterPanel: FunctionComponent<ISideFilterPanelProps> = (props) => {
  const {
    collapsible, defaultSize, children, hasActiveFilters, onClearAllFilters, headerActions, id = DEFAULT_PANEL_ID,
  } = props;

  // Count only renderable children (Children.toArray filters out null/undefined/boolean),
  // so conditionally-included blocks like {cond && <X />} don't reserve space.
  const filterCount = Children.toArray(children).length;
  // Header of FiltersPanel (FILTERS title) + all filter blocks in collapsed state
  const minHeight = (filterCount + 1) * SINGLE_FILTER_HEADER_HEIGHT;

  return (
    <>
      {collapsible && <ResizeHandle direction={'vertical'} withDivider={true} highlightSide={'start'} />}
      <FlexNavigationPanel id={id} defaultSize={defaultSize} minSize={0} minHeight={minHeight}>
        <FiltersPanel
          onClearAllFilters={onClearAllFilters}
          hasActiveFilters={hasActiveFilters}
          headerActions={headerActions}
        >
          {children}
        </FiltersPanel>
      </FlexNavigationPanel>
    </>
  );
};
